export default "__VITE_ASSET__f7999cd5__"